<template>
  <div class="HowItWorks">
    <h1 class="mainheader">About Us</h1>
    <div class="imageholder">
      <div class="Desc">
        <div class="descriptions">
          <div class="left top"></div>
          <img class="avators" src="../assets/About/20_yeas_back.svg" alt="">
          <div class="right">
            <h1>20 years back, life was very simple.</h1>
            <p>
              We used to have a cow in our backyard that gave us natural and
              fresh milk everyday. There was nothing to worry since we owned the
              animals.
            </p>
          </div>
        </div>

        <div class="descriptions">
          <div class="right middle"></div>
          <img class="avators" src="../assets/About/today.svg" alt="">
          <div class="right">
            <h1 class="middleHeading">Today.</h1>
            <p class="middleDesc">
              Many of us have moved to towns and our cities are rapidly growing.
            </p>
          </div>
        </div>
        <div class="descriptions">
          <div class="left top"></div>
          <img class="avators" src="../assets/About/the_milk.svg" alt="">
          <div class="right">
            <h1>The milk we consume</h1>
            <p>
              is either recombined with milk powder or takes days to reach our
              homes.
            </p>
          </div>
        </div>
        <div class="middleHeading">
          <h1>Can we be your backyard cow?</h1>
        </div>

        <div class="lowerSection">
          <div class="descriptions">
            <div class="right middle"></div>
            <img class="avators" src="../assets/About/who_we_are.svg" alt="">
            <div class="right">
              <h1 class="middleHeading">Who We Are</h1>
              <p class="middleDesc">
                We are a supply chain tech company and a team of milk experts.
              </p>
            </div>
          </div>
          <div class="descriptions">
            <div class="left top"></div>
            <img class="avators" src="../assets/About/our_aim.svg" alt="">
            <div class="right">
              <h1>Our Aim</h1>
              <p>
                We aim to bring back the basics of milk and a promise to
                natural, fresh and unadulterated milk directly to your doorstep.
              </p>
            </div>
          </div>
          <div class="descriptions">
            <div class="right middle"></div>
            <img class="avators" src="../assets/About/our_mission.svg" alt="">
            <div class="right">
              <h1 class="middleHeading">Our Mission</h1>
              <p class="middleDesc">
                We are on a mission to build the next generation of dairy
                products, addressing micronutrient deficiency (Hidden Hunger)
                and post harvest milk loss.
              </p>
            </div>
          </div>
        </div>
      </div>
      <img class="timeline" src="../assets/About/About-Timeline.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.HowItWorks {
  padding: 70px 0px 70px 0px;
  width: 100%;
}
.imageholder {
  position: relative;
  display: grid;
  place-items: center;
}
img {
  margin: auto;
  width: 793px;
}
img.avators{
  display: none;
}
.right h1 {
  text-align: left;
}
h1.middleHeading,
p.middleDesc {
  text-align: right;
}
h1.mainheader {
  font-weight: 700;
  color: #343540;
  font-family: "DM Sans";
  font-size: 36px;
  font-weight: 700;
  line-height: 47px;
  text-align: center;
}
h1 {
  font-weight: 900;
  color: #343540;
  font-family: "DM Sans";
  font-size: 20px;
  line-height: 26px;
}
.middleHeading h1 {
  padding: 20px;
  background-color: #fff;
  margin-top: 20px;
  font-weight: 900;
  color: #343540;
  font-family: "DM Sans";
  font-size: 26px;
  font-weight: 700;
  line-height: 34px;
  text-align: center;
}
.lowerSection {
  margin-top: 100px;
}
.right p {
  max-width: 420px;
  width: 345px;
  color: #343540;
  font-family: "DM Sans";
  font-size: 14px;
  line-height: 18px;
}
.Desc {
  position: absolute;
  top: 190px;
  width: 700px;
  max-width: 700px;
  display: grid;
}
.descriptions {
  display: flex;
  margin: 10px;
  height: 150px;
}
.left {
  width: 100%;
}
.bottom {
  margin-bottom: auto;
}
@media screen and (max-width: 720px) {
  .timeline {
    display: none;
  }
  img.avators{
    display: unset;
  height: 130px;
  width: inherit;
  margin-top: 50px;
}
  .Desc {
    position: unset;
    top: 190px;
    width: 100%;
    max-width: 700px;
    display: grid;
  }
  h1.middleHeading,
  p.middleDesc {
    text-align: center;
  }
  .left {
    display: none;
  }
  .descriptions {
    display: block;
    margin: unset;
    height: unset;
    width: 100%;
  }
  .middleHeading h1 {
    text-align: center;
    background-color: none;
    margin-top: 20px;
    font-weight: 900;
    color: #343540;
    font-size: 24px;
    line-height: 34px;
  }
  .right p {
    text-align: center;
    /* max-width: unset; */
    margin: auto;
    width: 90%;
    color: #343540;
    font-size: 18px;
    line-height: 18px;
  }
  .right h1 {
    text-align: center;
  }
  .middleHeading h1 {
  padding: 80px 20px 80px 20px;
  margin-top: 120px;
  font-weight: 900;
  color: #fff;
  background-color: #0077B6;
  font-family: "DM Sans";
  font-size: 26px;
  font-weight: 700;
  line-height: 34px;
  text-align: center;
}
}
</style>